import React from "react";
import "react-loading-skeleton/dist/skeleton.css";
import {
  Route,
  Routes,
  unstable_HistoryRouter as HistoryRouter,
} from "react-router-dom";
import customHistory from "./router/customHistory";

import "./styles.scss";
// Prime React
import "primeicons/primeicons.css";
import "primereact/resources/primereact.min.css";
import "primereact/resources/themes/lara-light-indigo/theme.css";
/*
Note: Not using prime flex because css will mix up. Although best thing would be to reconfigure everything using a single library: possibly prime react. 
*/
// import 'primeflex/primeflex.css';

// pages
import AdminAccount from "./pages/admin/adminAccountPage";
import Advice from "./pages/admin/advicePage";
import AnalyseClient from "./pages/admin/analyseClientPage";
import AnalyseExpert from "./pages/admin/analyseExpertPage";
import CabinetConfigurationPage from "./pages/admin/cabinetConfiguration";
import ClientList from "./pages/admin/clientListPage";
import ConfigurationPackage from "./pages/admin/configurationPackage";
import Consultation from "./pages/admin/consultationPage";
import Expert from "./pages/admin/expertPage";
import Home from "./pages/admin/homePage";
import Planning from "./pages/admin/planningPage";
import PromoCode from "./pages/admin/promoCode";
import PurchasePackage from "./pages/admin/purchasePackagePage";
// path
import Layout from "./components/layout/layout";
import NewPackage from "./pages/admin/configurationPackage/newPackage";
import NewPromoCode from "./pages/admin/promoCode/newPromoCode";
import PasswordReset from "./pages/password-reset";
import EditPackage from "./pages/admin/configurationPackage/editPackage";
import EditPromoCode from "./pages/admin/promoCode/editPromoCode";
import ModifyPassword from "./pages/modifyPassword";
import Email from "./pages/admin/email";
import OwnerHomePage from "./pages/owner/homePage";
import NotFoundRedirect from "./pages/404";
import MigrationPage from "./pages/migration";

//Webhook
import ForfaitsPage from "./pages/webhook/forfaits";
import NosExperts from "./pages/webhook/nosExpert";
import ProfilePage from "./pages/webhook/profile";
import ClientPage from "./pages/admin/clientPage";
import Experts from "./pages/webhook/expert";
import Sms from "./pages/admin/sms";
import NotificationPage from "./pages/admin/notificationPage";

function App() {
  return (
    <HistoryRouter history={customHistory}>
      <Routes>
        {/*----------------- Owner Routes --------------------------------------*/}
        <Route path="/:officeName/owner" element={<Layout role="owner" />}>
          <Route index Component={OwnerHomePage} />
        </Route>
        {/*----------------- Admin Routes --------------------------------------*/}
        <Route path="/:officeName/admin" element={<Layout role="admin" />}>
          <Route index Component={Home} />
          <Route path="consultation" Component={Consultation} />
          <Route path="planning/:calendarType" Component={Planning} />
          <Route path="experts" Component={Expert} />
          <Route path="analyseExpert" Component={AnalyseExpert} />
          <Route path="clientList" Component={ClientList} />
          <Route path="client/:clientId" Component={ClientPage} />
          <Route path="analyseClient" Component={AnalyseClient} />
          <Route path="promoCode">
            <Route index Component={PromoCode} />
            <Route path="new" Component={NewPromoCode} />
            <Route path="edit" Component={EditPromoCode} />
          </Route>
          <Route path="advice" Component={Advice} />
          <Route path="purchasePackage" Component={PurchasePackage} />
          <Route path="configurationPackage">
            <Route index Component={ConfigurationPackage} />
            <Route path="new" Component={NewPackage} />
            <Route path="edit" Component={EditPackage} />
          </Route>
          <Route
            path="cabinetConfiguration"
            Component={CabinetConfigurationPage}
          />
          <Route path="adminAccount" Component={AdminAccount} />
          <Route path="email" Component={Email} />
          <Route path="sms" Component={Sms} />
          <Route path="notification" Component={NotificationPage} />
        </Route>

        {/*----------------- Expert Routes --------------------------------------*/}
        <Route path="/:officeName/expert/*" Component={MigrationPage} />
        {/*----------------- Client Routes --------------------------------------*/}
        <Route path="/:officeName/client/*" Component={MigrationPage} />
        <Route path="/expert/*" Component={MigrationPage} />
        <Route path="/client/*" Component={MigrationPage} />
        {/*----------------- Webhook Routes --------------------------------------*/}
        <Route path="/webhook/:officeName/forfaits" Component={ForfaitsPage} />
        <Route
          path="/webhook/:officeName/profile/:expertId"
          Component={ProfilePage}
        />
        <Route
          path="/webhook/:officeName/experts/:profileUrl"
          Component={NosExperts}
        />
        <Route
          path="/webhook/:expertId/expert/:profileUrl"
          Component={Experts}
        />
        {/*----------------- General Routes --------------------------------------*/}
        <Route
          path="/:officeName/modify-password/:token/:email"
          Component={ModifyPassword}
        />
        <Route path="/:officeName/login" Component={MigrationPage} />
        <Route path="/:officeName/register" Component={MigrationPage} />
        <Route path="/:officeName/password" Component={PasswordReset} />
        <Route path="*" element={<NotFoundRedirect />} />
      </Routes>
    </HistoryRouter>
  );
}

export default App;
